import React from 'react';

import classNames from 'classnames';

import { ReactComponent as IconChevronThin } from 'media/svg/chevronThin.svg';

import styles from '../Slider.module.scss';

interface NavigationElementProps {
    type: 'prev' | 'next';
    uuid?: string;
    customClass?: string;
    clickHandler?: (e: React.MouseEvent) => void;
    onKeyDown?: (e: React.KeyboardEvent) => void;
}

const NavigationElement = React.forwardRef<
    HTMLDivElement,
    NavigationElementProps
>((props, ref) => {
    const { type, uuid, customClass, clickHandler, onKeyDown } = props;
    const isPrev = type === 'prev';
    const isNext = type === 'next';

    return (
        <div
            tabIndex={-1}
            role={'button'}
            className={classNames({
                [`jsPrev-${uuid}`]: uuid && isPrev,
                [styles.ButtonPrev]: isPrev,
                [`jsNext-${uuid}`]: uuid && isNext,
                [styles.ButtonNext]: isNext,
                [customClass ?? '']: !!customClass,
            })}
            ref={ref}
            onClick={clickHandler}
            onKeyDown={onKeyDown}
            aria-label={isPrev ? 'swipe previous' : 'swipe next'}
        >
            <IconChevronThin />
        </div>
    );
});

NavigationElement.displayName = 'NavigationElement';

export default NavigationElement;
